import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {firstValueFrom, Observable, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {Centre} from '../../../../interfaces/Centres';
import {CentreService} from '../../../../services/centre.service';
import {FullChild} from '../../../../interfaces/FullChild';
import {ChildService} from '../../../../components/child/child.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MatSelectChange} from "@angular/material/select";
import html2pdf from "html2pdf.js";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute} from "@angular/router";
import {CdkDrag} from "@angular/cdk/drag-drop";
import {MatDialog} from "@angular/material/dialog";
import {auto} from "@popperjs/core";
import {ChartConfiguration, ChartData, ChartDataset, ChartEvent, ChartType} from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
// import 'chartjs-plugin-datalabels';
import html2canvas from "html2canvas"; // Import the plugin
import { PhotoGalleryComponent } from 'src/app/components/photo-gallery/photo-gallery.component';
import {endOfDay} from '../../../../utils/date-range-format.service';
export type ChartOptions = ChartConfiguration['options']; // Use the broader type

@Component({
  selector: 'app-impact-report-counseling',
  templateUrl: './view-impact-report-counseling.component.html',
  styleUrls: ['./view-impact-report-counseling.component.scss'],
})
export class ViewImpactReportCounselingComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @ViewChild('content') content!: ElementRef;
  centre: any
  mStartDate: null | Date = null;
  mEndDate: null | Date = null;
  childDetails: any;
  centres$: Observable<Centre[]>;
  selectedImages: string[] = [];
  showAdmissionChart=false
  selectedCentre = 'All';
  selectedCentreName = '';
  impactReport: any;
  problemAddressed = '';
  intervention2: any
  problemAddressed2: any
  counselling = '';
  intervention = '';
  groupCounselling = '';
  mAdmissionsAssessment: any;
  mDischargeAssessment: any;
  mDischargeChartData: number[] = [];
  mAdmissionChartData: number[] = [];
  individualSessionsControl:any
  colors: any[] = [{backgroundColor: ['#0b5ba8', '#6114be', '#15dcdc']}];
  smileys = [
    { src: '../../../../../assets/images/smiley/greenSmiley.png', alt: 'green smiley' },
    { src: '../../../../../assets/images/smiley/neutral.png', alt: 'neutral smiley' },
    { src: '../../../../../assets/images/smiley/redEmoji.png', alt: 'sad smiley' }
  ];
  // @ts-ignore
  isHidden: boolean = false;
showDischargeChart=false
  // Function to hide the mat-form-field
  hideField() {
    this.isHidden = true;
  }
  doughnutChartOptions: ChartConfiguration<'pie'>['options'] = {
    responsive: false,
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      // @ts-ignore
      // Add dataLabels plugin configuration
      dataLabels: {
        display: true, // Enable data labels
        formatter: (value: number, context: ChartEvent) => {
          // @ts-ignore
          const label = context.dataset.label || ''; // Get dataset label
          return `${label}: ${value}%`; // Format label with percentage
        },
        fontColor: 'black', // Adjust data label text color
        fontSize: 14, // Adjust data label font size
      }
    },
  };  // doughnutChartLabels: string[] = ['Difficulty in Coping up', 'Sometimes', 'Able to Cope up'];
  doughnutChartLabels: string[] = ['Difficulty in coping', 'Able to Cope up', 'Sometimes'];
  doughnutChartDatasets1?: ChartConfiguration<'pie'>['data']['datasets'];
  apexChartData1:number[]=[]
  apexChartData2:any
  doughnutChartDatasets2?: ChartConfiguration<'pie'>['data']['datasets'];
  mAllAssessments: any[] = []
  mAllGroupSessions: any[] = []
  mAllIndividualSessions: any[] = []
  mId: string | undefined;
  mData: any;
  sessionCounts!: { groupSessions: number; individualSessions: number; assessmentSessions: number };
  selectedSubmit: any;
  isFormFieldDisabled = false;
  selectedGalleryImages: string[] = []
  galleryImages: any[] = [];
  previewImageUrl: string | null = null;
  showPreview: boolean = false;
  para1=" The Counselling Program of Access Life Assistance Foundation was\n" +
    "          started with the intention that no family should abandon the treatment. “The objective\n" +
    "          of the psychological interventions done at Access Life is focused on assisting the\n" +
    "          family and the child to cope with the stress of the diagnosis, treatment &amp; prognosis of\n" +
    "          the illness while adjusting to living with other families in a new city. Towards this, the\n" +
    "          assessments and interventions are being planned and implemented by our\n" +
    "          psychologists."
  para2= "Each family’s individual counselling sessions are carried out twice a month and group family\n" +
    "          sessions are conducted once every month. Psychological assessments are carried out once\n" +
    "          every two months to evaluate our course of counselling interventions. The data obtained is\n" +
    "          analysed to determine the level of coping abilities and the beneficiaries&#39; mental/emotional\n" +
    "          well-being."
  endLine1: string = "Currently,  families are staying with us. All family’s individual counselling sessions are carried out twice a month and Intermediate Psychological assessments are carried out once every two months to evaluate our course of counseling interventions. Group sessions are held once every month."

  endLine: string = "Currently,  families are staying with us. All family’s individual counseling sessions arecarried out twice a month and Intermediate Psychological assessments are carried out once every two months toevaluate our course of counseling interventions. Group sessions are held once every month."

  constructor(
    private mCentreService: CentreService,
    private mFirestore: AngularFirestore,
    private childService: ChildService,
    private mSnackbar: MatSnackBar,
    private route: ActivatedRoute,
    private matDialog:MatDialog
  ) {
    this.centres$ = this.mCentreService.getAllCentres().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    );


    route.params.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mId = res['id']
      console.log("mid", this.mId)

      if (this.mId) this.mFirestore.collection(this.env.counsellingImpactReport).doc(this.mId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
        if (this.mId != undefined) {
          this.mData = res
          this.mStartDate = res.from.toDate();
          this.mEndDate = res.to.toDate();
          this.selectedCentre = res.centreCode;
          this.problemAddressed = res.problemAddressed;
          this.counselling = res.counselling;
          this.intervention = res.intervention;
          this.para1 = res.para1
          this.para2 = res.para2
          this.endLine = res.endLine
          this.endLine1 = res.endLine1
          this.groupCounselling = res.groupCounselling;
          this.mAllIndividualSessions.length = res.sessionCounts.individualSessions;
          this.mAllGroupSessions.length = res.sessionCounts.groupSessions
          this.mAllAssessments.length = res.sessionCounts.assessmentSessions
          this.centre = { centreName: res.centreName, centreCode: res.centreCode }

          // Load saved images
          this.selectedImages = res.images || [];
          this.galleryImages = res.galleryImages || [];

          this.savedCounts = res.sessionCounts || null;

          if (this.hasSavedCharts(res)) {
            this.restoreSavedCharts(res);
          } else {
            // legacy reports saved before chart snapshots existed: rebuild from live data
            this.searchData()
            setTimeout(() => { this.searchData() }, 300)
          }
        }
      })
    })
  }

  ngOnInit(): void {
    // Initialization logic if needed
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  savedCounts: { individualSessions?: number; groupSessions?: number; assessmentSessions?: number} | null = null;

  /** Individual + Assessment + Group */
  getGrandTotalSessions(): number {
    const c = this.savedCounts;
    if (!c) return 0;
    return [c.individualSessions, c.assessmentSessions, c.groupSessions]
      .reduce((sum: number, v: any) => sum + (Number(v) || 0), 0);
  }

  private hasSavedCharts(data: any): boolean {
    return Array.isArray(data.admissionChartData) || Array.isArray(data.dischargeChartData);
  }

  private restoreSavedCharts(data: any): void {
    this.mAdmissionChartData = Array.isArray(data.admissionChartData) ? data.admissionChartData : [];
    this.apexChartData1 = [...this.mAdmissionChartData];
    this.mDischargeChartData = Array.isArray(data.dischargeChartData) ? data.dischargeChartData : [];
    this.apexChartData2 = [...this.mDischargeChartData];
    this.showDischargeChart = this.mDischargeChartData.some(v => v > 0);
    this.showAdmissionChart = this.showDischargeChart && this.mAdmissionChartData.some(v => v > 0);
  }

  async searchData() {
    try {
      // Convert observables to promises
      const individualSessionRef = this.mFirestore.collection(`${this.env.counseling}/allSessions/sessions`, ref =>
          ref.where('centreCode', '==', this.selectedCentre)
              //.where('type','==','Regular Counselling')
              .where('type', 'in', ['Regular Counselling', 'Follow-up Counselling'])
              .where('date', '>=', this.mStartDate)
              .where('date', '<=', endOfDay(this.mEndDate))
      ).valueChanges();

      const groupSessionRef = this.mFirestore.collection(`${this.env.counseling}/allSessions/groupSessions`, ref =>
          ref.where('date', '>=', this.mStartDate)
              .where('date', '<=', endOfDay(this.mEndDate))
              .where('centreCode', '==', this.centre.centreCode)
      ).valueChanges();
//newl added logic by sumeet
      const assessmentRef = this.mFirestore.collection(`${this.env.assessment}/allAssessments/assessments`, ref =>
          ref.where('centreCode', '==', this.selectedCentre)
              .where('dateOfAssessment', '>=', this.mStartDate)
              .where('dateOfAssessment', '<=', endOfDay(this.mEndDate))
              .where('type', 'in', ['Admission Baseline Assessment', 'Discharge Assessment'])
      ).valueChanges();

      // Fetch all data in parallel using async/await
      const [individualSessions, groupSessions, assessments] = await Promise.all([
        firstValueFrom(individualSessionRef),
        firstValueFrom(groupSessionRef),
        firstValueFrom(assessmentRef)
      ]);

      // Process Individual Sessions
      this.mAllIndividualSessions = individualSessions;
      this.intervention2 = this.mAllIndividualSessions
          .filter(session => session.interventions !== undefined)
          .map(session => session.interventions);

      const uniqueInterventions = new Set(this.intervention2.flat());
      this.intervention2 = Array.from(uniqueInterventions);
      if (!this.intervention) {
        this.intervention = this.intervention2.join('\n');
      }

      this.problemAddressed2 = this.mAllIndividualSessions
          .filter(session => session.challengesFaced !== undefined)
          .map(session => session.challengesFaced);

      const uniqueProblems = new Set(this.problemAddressed2.flat());
      this.problemAddressed2 = Array.from(uniqueProblems);
      if (!this.problemAddressed) {
        this.problemAddressed = this.problemAddressed2.join('\n');
      }

      console.log("Unique Problems Addressed:", this.problemAddressed);
      console.log('mAllIndividualSessions', this.mAllIndividualSessions);
      console.log('mAllIndividualSessions', this.intervention2);
      this.individualSessionsControl = this.mAllIndividualSessions

      // Process Group Sessions
      this.mAllGroupSessions = groupSessions;
      // this.groupSessionsControl= groupSessions.length
      console.log('mAllGroupSessions', groupSessions.length);
      console.log('mAllGroupSessionsSorted', this.mAllGroupSessions.length);

      // Process Assessments
      this.mAllAssessments = assessments;
      // this.totalAssesssmentSessionsControl=assessments.length
      console.log('mAllAssessments', assessments.length);

      // Initialize chart data
      this.mAdmissionChartData = [];
      this.mDischargeChartData = [];
      this.mAdmissionsAssessment = null;
      this.mDischargeAssessment = null;
      this.doughnutChartDatasets1 = undefined;
      this.doughnutChartDatasets2 = undefined;

      // Fetch additional data for charts
      const dischargeAssessmentPromise = new Promise((resolve, reject) => {
        this.fetchAssessmentData('Discharge Assessment', this.selectedCentre, (res: any) => {
          this.mDischargeAssessment = res;
          if (this.mDischargeAssessment != null) {
            this.startDischargeChart();
          }
          resolve(res);
        });
      });

      const admissionAssessmentPromise = new Promise((resolve, reject) => {
        this.fetchAssessmentData('Admission Baseline Assessment', this.selectedCentre, (res: any) => {
          this.mAdmissionsAssessment = res;
          if (this.mAdmissionsAssessment != null) {
            this.startAdmissionChart();
          }
          resolve(res);
        });
      });

      // Wait for additional data fetching to complete
      await Promise.all([dischargeAssessmentPromise, admissionAssessmentPromise]);

      // Only show admission chart if discharge data is also present
      if (this.showDischargeChart && this.mAdmissionsAssessment?.length >= 1) {
        this.showAdmissionChart = true;
      }

    } catch (error) {
      console.error("Error fetching data", error);
    }
  }


  fetchAssessmentData(assessmentType: string, selectedCentre: string, callback: Function) {

    if (this.mAllAssessments && this.mAllAssessments.length > 0) {
      let data = this.mAllAssessments.filter((x: any) => x.type == assessmentType)
      console.log(`SORTED BY ${assessmentType}`, data.length)
      callback(data);
    }

  }


  private startDischargeChart() {
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
    this.mDischargeAssessment.forEach((it: any) => {
      totalYes += it.assessment.filter((x: any) => x.ans == 'Yes').length;
      totalNo += it.assessment.filter((x: any) => x.ans == 'No').length;
      totalSometimes += it.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    })
    // // Refactored startDischargeChart() function
    // const totalYes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Yes').length;
    // const totalNo = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'No').length;
    // const totalSometimes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    const total = totalYes+totalNo +totalSometimes
    const totalYesPercentage= Number(((totalYes/total)*100).toFixed(2))
    const totalNoPercentage= Number(((totalNo/total)*100).toFixed(2))
    const totalSometimesPercentage= Number(((totalSometimes/total)*100).toFixed(2))
    this.mDischargeChartData = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
    // this.mDischargeChartData = [totalYes, totalNo, totalSometimes];
    this.apexChartData2= this.mDischargeChartData

    this.doughnutChartDatasets2 = [
      {data: this.mDischargeChartData, label: 'Discharge',backgroundColor: ["#ed7d31", "#70ad47", "#FFC000"]},
    ];
    if(this.mDischargeAssessment.length>=1)   this.showDischargeChart = true
  }

  private startAdmissionChart() {
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
    this.mAdmissionsAssessment.forEach((it: any) => {
      totalYes += it.assessment.filter((x: any) => x.ans == 'Yes').length;
      totalNo += it.assessment.filter((x: any) => x.ans == 'No').length;
      totalSometimes += it.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    })
    console.log('AtotalYes', totalYes)
    console.log('AtotalNo', totalNo)
    console.log('AtotalSometimes', totalSometimes)
    const total = totalYes+totalNo +totalSometimes
    const totalYesPercentage= Number(((totalYes/total)*100).toFixed(2))
    const totalNoPercentage= Number(((totalNo/total)*100).toFixed(2))
    const totalSometimesPercentage= Number(((totalSometimes/total)*100).toFixed(2))
    this.mAdmissionChartData = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
    this.apexChartData1= [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
    this.doughnutChartDatasets1 = [
      {data: this.mAdmissionChartData, label: 'Admission',backgroundColor: ["#ed7d31", "#70ad47", "#FFC000"]},
    ];
  }

  onCentreSelect($event: MatSelectChange) {
    let c = $event.value as Centre
    this.selectedCentre = c.centreCode
    this.selectedCentreName = c.centreName
    this.centre = {"centreCode": c.centreCode, "centreName": c.centreName}
    console.log('OncentreSelect', this.centre)
  }

  printDoc() {
    let printContents;
    const previewElement = document.getElementById('previewCounselingReports');
    if (previewElement) {
      printContents = previewElement.innerHTML;
    } else {
      console.error('Element with ID "preview" not found.');
      return; // Exit the function if the element is not found
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Counselling-Impact-Report</title>
            <style>
              *, *::before, *::after { box-sizing: border-box; }

              body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
                font-size: 13px;
                color: #000;
              }

              .page {
                padding: 16px 24px;
                margin: 0 auto;
                max-width: 900px;
              }

              /* Non-preview images (logo, etc.) — cap width, preserve aspect ratio */
              img {
                max-width: 100%;
                display: block;
              }

              /* ── Photo grid: matches live component SCSS exactly ── */
              .preview-image-grid {
                display: flex;
                flex-wrap: wrap;
                gap: 14px;
                margin-top: 8px;
              }

              /* Fixed square wrap — same as live .preview-img-wrap */
              .preview-img-wrap {
                position: relative;
                width: 160px;
                flex-shrink: 0;
                break-inside: avoid;
                page-break-inside: avoid;
              }

              /* Fixed square image — object-fit:cover keeps all images same size */
              .preview-img {
                width: 160px;
                height: 160px;
                object-fit: cover;
                border: 1px solid #ccc;
                border-radius: 4px;
                display: block;
              }

              .preview-img-caption {
                font-size: 10px;
                color: #666;
                text-align: center;
                margin-top: 3px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 160px;
              }

              /* ── Section headers ── */
              .preview-section { margin-top: 24px; margin-bottom: 8px; }

              .preview-section-header {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 12px;
              }

              .preview-section-dot {
                width: 14px;
                height: 14px;
                border-radius: 50%;
                flex-shrink: 0;
              }

              .preview-section-title {
                font-size: 15px;
                font-weight: 700;
                margin: 0;
                text-transform: uppercase;
                letter-spacing: 0.5px;
              }

              .preview-section-line {
                flex: 1;
                height: 2px;
                background: #ccc;
              }

              /* ── Pie-chart summary row ── */
              .pie-summary {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 8px 24px;
                margin-top: 8px;
                font-size: 13px;
              }

              .pie-summary-row {
                display: flex;
                align-items: center;
                gap: 6px;
              }

              .pie-dot {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                flex-shrink: 0;
              }

              .pie-pct { font-weight: 600; }

              @media print {
                body { margin: 0; padding: 0; }
                .page { padding: 10px 20px; }
                /* DO NOT override .preview-img height here — fixed px + object-fit handles uniformity */
                .preview-img-actions { display: none !important; }
              }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            <div class="page">
              ${printContents}
            </div>
          </body>
        </html>
      `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }

  }
  onFilesSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles.item(i);
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const result = e.target.result;
            if (!this.selectedImages.includes(result)) {
              this.selectedImages.push(result);
            }
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  save() {
    let obj = {
      problemAddressed: this.problemAddressed,
      counselling: this.counselling,
      intervention: this.intervention,
      groupCounselling: this.groupCounselling,
      centreCode: this.selectedCentre,
      from: this.mStartDate,
      to: this.mEndDate,
      createdAt: new Date(),
      sessionCounts: {
        ...(this.savedCounts || {}),
        individualSessions: this.mAllIndividualSessions.length,
        groupSessions: this.mAllGroupSessions.length,
        assessmentSessions: this.mAllAssessments.length,
      },
      submitType: this.selectedSubmit,
      images: this.selectedImages,
      galleryImages: this.galleryImages,
    };

    console.log(obj);


    if (this.mId !== undefined) {
      this.mFirestore
        .collection(this.env.counsellingImpactReport)
        .doc(this.mId)
        .update(obj)
        .then(() => {
          this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000);
          this.printDoc();
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });
    } else {
      this.mFirestore
        .collection(this.env.counsellingImpactReport)
        .add(obj)
        .then(() => {
          this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000);
          this.printDoc();
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
    }
  }

  getTotalSessions() {
    this.individualSessionsControl=this.mAllIndividualSessions.length;
    return this.mAllIndividualSessions.length
  }

  getValues($event: MatSelectChange) {
    this.selectedSubmit = $event.value
    console.log(this.selectedSubmit)

  }

  openGallery() {
    const dialogRef = this.matDialog.open(PhotoGalleryComponent, {
      height: '90%',
      width: 'auto',
      data: {
        type: 'Counselling',
        path: `ALDocuments/Counselling/groupSessions`,
        startDate: this.mStartDate,
        endDate: this.mEndDate,
        centreCode: this.selectedCentre
      }
    });
    dialogRef.afterClosed().subscribe((urls: string[]) => {
      if (!urls || !urls.length) return;
      const newImages = urls.map(url => ({
        url,
        fileName: url.split('%2F').pop()?.split('?')[0] || '',
        centreName: this.selectedCentreName
      }));
      this.galleryImages = [...this.galleryImages, ...newImages];
    });
  }

  openImagePreview(url: string) {
    this.previewImageUrl = url;
    this.showPreview = true;
  }

  closeImagePreview() {
    this.showPreview = false;
    this.previewImageUrl = null;
  }

  openImageInNewTab(url: string) {
    window.open(url, '_blank');
  }

  removeImageFromGallery(index: number) {
    if (index >= 0 && index < this.galleryImages.length) {
      this.galleryImages.splice(index, 1);
    }
  }
}
